import React, { useState } from 'react';
import styled from 'styled-components';
import ReactPlayer from 'react-player';

const Container = styled.div`
  width: 100%;
  position: relative;
`;

const PlayerVideo = ({ videoSrc }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const onLoadedData = () => {
    setIsVideoLoaded(true);
  };

  return (
    <Container>
      <div style={{ opacity: isVideoLoaded ? 1 : 0 }}>
        <ReactPlayer
          className="react-player"
          width="100%"
          height="100%"
          url={videoSrc}
          playing={false}
          controls
          loop
          playsinline
          onReady={onLoadedData}
        />
      </div>
    </Container>
  );
};
export default PlayerVideo;
